import BaseFileEditorMixin from "@/modules/core/file/protected/BaseFileEditorMixin";
import service from "./MicroCreditFileService";
import FileForm from "./MicroCreditFileForm";

export default {
  mixins: [BaseFileEditorMixin],

  created() {
    this.FileForm = FileForm;
    this.fileContextServerPath = "micro-credit/files";
    this.requestContextServerPath = "micro-credit/requests";
    //this.externalContext = 'MICRO_CREDIT_FILE';
  },

  methods: {
    getService() {
      return service;
    }
  }
};
